module.exports = __webpack_public_path__ + "media/images/riders/ALESSANDRA_KELLER-c472ea1c1a05c87814a7822f88847dfe.png";